import { combineReducers } from "redux";
import folderWizardReducers from "./wizard/reducers";
import folderSidebarReducer from "./sidebar/reducer";
import folderNextStatesReducer from "./edit/states/reducer";
import financedOffersReducers from "./edit/generalData/financedOffers/reducers";
import folderGeneralInfoReducer from "./edit/generalData/info/reducer";
import initialState from "reducers/initialState";

const currentFolderReducers = combineReducers({
  header: folderWizardReducers.folderHeaderReducer,
  warnings: folderWizardReducers.folderWarningsReducer,
  nextStates: folderNextStatesReducer,
  sidebarData: folderSidebarReducer,
  generalInfo: folderGeneralInfoReducer,
  financedOffers: financedOffersReducers.financedOffersReducer,
  clientOffers: financedOffersReducers.clientOffersReducer,
  offerPartners: financedOffersReducers.folderOfferPartnersReducer
});

export default function currentFolderReducer(state = initialState.currentFolder, action) {
  const intermediateState = folderWizardReducers.currentFolderReducer(state, action);
  const finalState = currentFolderReducers(intermediateState, action);
  return { ...intermediateState, ...finalState };
}
